import React from 'react';

/**
 * Ornement latéral style verset coranique (crochet + rosette).
 * `mirrored` pour le côté opposé.
 */
const QuranVerseOrnament = ({ mirrored = false, className = '' }) => (
  <svg
    className={className}
    viewBox="0 0 36 92"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    style={mirrored ? { transform: 'scaleX(-1)' } : undefined}
  >
    <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <path
        d="M27 8 C14 22, 11 46, 13 62 C15 74, 21 82, 28 86"
        strokeWidth="2"
      />
      <path
        d="M22 12 C16 22, 14 44, 16 56 C17 66, 21 74, 25 78"
        strokeWidth="1.2"
        opacity="0.45"
      />
    </g>

    <g fill="currentColor">
      <circle cx="18" cy="18" r="1.5" />
      <circle cx="18" cy="74" r="1.5" />
    </g>

    <g fill="currentColor" stroke="currentColor" strokeWidth="0.8">
      <polygon points="18,40 20.2,44.8 25.4,44.8 21.2,48 22.8,53 18,49.8 13.2,53 14.8,48 10.6,44.8 15.8,44.8" />
      <circle cx="18" cy="46.5" r="2.2" fill="none" />
      <circle cx="18" cy="46.5" r="0.9" fill="currentColor" stroke="none" />
    </g>
  </svg>
);

export default QuranVerseOrnament;
